/* Copyright (c) 2017 Backpack Health LLC */

import React, { FC } from 'react';

import './GroupBanner.scss';

import { I18nImageType } from '../../../../../models/GroupMetadata';
import { I18nImage } from '../../../../components/I18nTranslation';

interface Props {
  imageBanner: I18nImageType;
}
const GroupBanner: FC<Props> = (props) => {
  const { imageBanner } = props;

  if (!imageBanner || !imageBanner.default) { return null; }

  return (
    <div className="cmp-groupbanner">
      <I18nImage data={imageBanner} />
    </div>
  );
};

export default GroupBanner;
